module.exports = __webpack_public_path__ + "static/img/Brent-Daniels.198fd73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brent-Daniels.jpg
// module id = HtV5
// module chunks = 0